import { createComponent } from '@carvana/merch-components';
import styled from 'styled-components';
import Image from '@/common/Image';

export const ImageHeight = 187;
export const CardMaxWidth = 332;
const BadgeHeight = 36;
const BadgeWidth = 128;

export const Card = styled.div.attrs({
  className: 'border border-grey-2 relative rounded-[6px]'
})`
  max-width: ${CardMaxWidth}px;
`;

export const Img = styled(Image)`
  border-radius: 6px 6px 0 0;
  height: ${ImageHeight}px;
  object-fit: cover;
  width: ${CardMaxWidth}px;
`;

export const TextBox = styled.div.attrs({
  className: 'bg-white flex flex-col items-start px-12 py-24 text-blue-7 w-full'
})`
  border-radius: 0 0 6px 6px;
`;

export const Dot = styled.span.attrs({
  className: 'bg-blue-7 inline-block mx-4 vertical-align-middle'
})`
  height: 4px;
  width: 4px;
  border-radius: 50%;
`;

export const InnerTextWrapper = createComponent('div', {
  className: 'flex w-full items-end justify-between'
});

export const ArrivalBanner = styled.div.attrs({
  className:
    'absolute bg-green-2 flex items-center justify-center rounded tl-header-xs text-white'
})`
  width: ${BadgeWidth}px;
  height: ${BadgeHeight}px;
  top: ${ImageHeight - BadgeHeight / 2}px;
  left: calc(50% - (${BadgeWidth}px / 2));
`;
